import type { PretendDeathCommandData } from '@festina/life-general-types/life'
import { typeUtils } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import type { CommandDataFormProps } from '../commandActions/CommandDataFormAndSimulation'
import { LifeLazyForm } from '../forms/LifeLazyForm'
import { initialFormEntriesFromVBase } from '../forms/yup/validation/yupValidationUtils'
import { LifeInput } from '../inputs/LifeInput'

const validateKey = typeUtils.createValidator<PretendDeathCommandData>()

export const PretendDeathForm = (
  props: CommandDataFormProps<PretendDeathCommandData>,
) => {
  const translate = useTranslate()

  return (
    <LifeLazyForm
      {...props}
      mapInitialValues={(frame): PretendDeathCommandData => ({
        _type: 'PretendDeathCommandData',
        ...initialFormEntriesFromVBase(frame),
      })}
    >
      <LifeInput
        fallbackInputType="date"
        label={translate('pretendDeathModalButton.deathDate')}
        name={validateKey('deathDate')}
      />
    </LifeLazyForm>
  )
}
